import { concessionLetterRequired, isencaoIR } from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const IsencaoDocs = () => {
  const rules = {
    anexoLaudoINSS: dynamicRule('required'),
    anexoLaudoMedicoIsencao: dynamicRule(),
    anexoCarta: dynamicRule('required'),
  };

  const docs = {
    commons: [...isencaoIR, ...concessionLetterRequired],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
